import { useEffect, useState } from 'react'
import * as verificationApi from '@/utils/signupVerificationApi'
import type { VerificationChannel } from '@/utils/signupVerificationApi'

/**
 * Canais que o BFF exige no cadastro, lidos uma vez ao montar a tela.
 * `null` enquanto a config não chegou (ou falhou) — o stepper então desenha a
 * jornada completa.
 */
export function useVerificationChannels() {
  const [channels, setChannels] = useState<VerificationChannel[] | null>(null)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      const result = await verificationApi.config()
      if (!cancelled && result.ok) setChannels(result.channels)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return [channels, setChannels] as const
}
